export class User {
    UserEmail: string;
    CreatedBy:string;
    ModifiedBy:string;
    CreatedDate: Date;
    ModifiedDate:Date;
    UserActive: boolean;
    UserName:string;
}